import { render } from "./CreateOffer.vue?vue&type=template&id=810346e2&scoped=true&ts=true&lang=pug"
import script from "./CreateOffer.vue?vue&type=script&lang=ts"
export * from "./CreateOffer.vue?vue&type=script&lang=ts"

import "./CreateOffer.vue?vue&type=style&index=0&id=810346e2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-810346e2"]])

export default __exports__